import { Flex, useMantineTheme } from "@mantine/core";
import { NavLinkMatrix } from "../../components";
import { ILinkItem, client_selected } from "../../client";
import { useTranslation } from "react-i18next";

type IProps = {
  item: ILinkItem[];
};

const SubNavLinks = ({ item }: IProps) => {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const redirectClient = client_selected.redirect;

  return (
    <>
      {item.map((navLink, index) => {
        return (
          <Flex
            w="fit-content"
            gap={{ base: 12, 991: 16 }}
            h={28}
            align="center"
            key={`subnav${navLink.path}${index}`}
          >
            <NavLinkMatrix
              label={t(navLink.name)}
              to={!!navLink?.path ? navLink?.path : redirectClient}
              sx={{
                span: {
                  fontSize: "14px",
                  lineHeight: "22px",
                  "@media (max-width: 1400px)": {
                    fontSize: "13px",
                    lineHeight: "20.2px",
                  },
                },
              }}
            />
            {item.length >= index + 2 ? (
              <Flex pt="5px">
                <Flex
                  style={{
                    display: "flex",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: theme.colors.complementary[6],
                    color: theme.colors.complementary[6],
                    content: "''",
                  }}
                />
              </Flex>
            ) : null}
          </Flex>
        );
      })}
    </>
  );
};

export default SubNavLinks;
